import { LOAD_SITE_INFO, LOAD_SYS_PARAMS } from '../actions/systemActions';

function system(
  state = {
    siteInfo: {},
    sysParams: {},
  },
  action
) {
  switch (action.type) {
    case LOAD_SITE_INFO:
      return {
        ...state,
        siteInfo: action.payload,
      };

    case LOAD_SYS_PARAMS:
      return {
        ...state,
        sysParams: action.payload,
      };

    default:
  }

  return state;
}

export default system;
